import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';

export const v1_login = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/login`;
    return customAxios.post(url, model).then((res) => {
        return res.data;
    })
}



export const v1_logout = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/logout`;
    return customAxios.post(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v1_unlock = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/unlock`;
    return customAxios.post(url, model).then((res) => {
        return res.data;
    })
}


export const v3_activity_logs = async (limit, page, fromDate, toDate) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/activity-logs/${limit}/${page}/${fromDate}/${toDate}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v1_forgot_password = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/forgot-password`;
    return customAxios.post(url, model).then((res) => {
        return res.data;
    })
}

export const v1_reset_password = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/reset-password`;
    return customAxios.post(url, model).then((res) => {
        return res.data;
    })
}